import { merge, compact } from 'lodash'
import { useCallback } from 'react'
import { useAuthentication } from '../../contexts/AuthenticationContext.jsx'
import fetchJSON from './fetchJSON.js'
import toUrlSearchParams from './toUrlSearchParams.js'

const useAuthenticatedResource = (url, options = {}) => {
  const { getValidToken } = useAuthentication()

  const getAuthenticatedOptions = useCallback((accessToken) => {
    return merge({}, options, {
      headers: {
        Authorization: accessToken ? `Bearer ${accessToken}` : undefined,
      },
    })
  }, [options])

  const get = useCallback((props = {}) => {
    const { params } = props
    const queryString = toUrlSearchParams(params).toString()
    const fullUrl = compact([url, queryString]).join('?')

    return getValidToken()
      .then((accessToken) => fetchJSON(fullUrl, 'GET', getAuthenticatedOptions(accessToken)))
  }, [url, getValidToken, getAuthenticatedOptions])

  return { get }
}

export default useAuthenticatedResource
